import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';

import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './SensorsListInput.module.scss';

const SensorsListInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  return (
    <div className={S.sensorsListContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet de sélectionner une liste de capteurs par
          leur ID.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            valeur={argument.description || ''}
            changement={(e) => onChange('description', e.target.value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>
            Valeur par défaut (IDs séparés par des virgules)
          </label>
          <ChampDeTexte
            valeur={argument.valeurParDefaut || ''}
            changement={(e) => onChange('valeurParDefaut', e.target.value)}
            placeholder="1,2,3 ou laisser vide"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            changement={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Nombre minimum de capteurs</label>
          <ChampDeTexte
            type="number"
            valeur={argument.options?.minCapteurs || ''}
            changement={(e) =>
              handleOptionChange('minCapteurs', parseInt(e.target.value) || 0)
            }
            placeholder="0"
            min="0"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Nombre maximum de capteurs</label>
          <ChampDeTexte
            type="number"
            valeur={argument.options?.maxCapteurs || ''}
            changement={(e) =>
              handleOptionChange('maxCapteurs', parseInt(e.target.value) || 0)
            }
            placeholder="Illimité si vide"
            min="1"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.permitMultiple || true}
            changement={(checked) =>
              handleOptionChange('permitMultiple', checked)
            }
            label="Permettre la sélection multiple"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.filtrerParProjet || false}
            changement={(checked) =>
              handleOptionChange('filtrerParProjet', checked)
            }
            label="Filtrer les capteurs par projet actuel"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.afficherNomCapteur || true}
            changement={(checked) =>
              handleOptionChange('afficherNomCapteur', checked)
            }
            label="Afficher le nom des capteurs (en plus de l'ID)"
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Liste de capteurs ID
              {argument.options?.permitMultiple && ' (sélection multiple)'}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SensorsListInput;
